import {AddPickupPointComponent } from './route/pickupPoints';



export const RosteringPageDeclaration: any = [
    AddPickupPointComponent
];


